import notFound from './components/common/NotFound.vue';
import postComponent from './components/post/PostComponent.vue';
import topTalk from './components/talk/TalkComponent.vue';
import topCalendar from './components/event/CalendarComponent.vue';
import topMember from './components/member/MemberList.vue';
import topAlbum from './components/album/AlbumComponent.vue';
import communityCreate from './components/community/CommunityCreate.vue';
import communitySetting from './components/community/CommunitySetting.vue';
import memberInvite from './components/member/MemberInvitation.vue';
import viewInvitation from './components/member/ViewInvitation.vue';
import mypageSetting from './components/setting/MyPageSetting.vue';
import setting from './components/setting/Setting.vue';

export default [
  {
    path: '/',
    component: postComponent,
    meta: { title: 'header.home', logo: { m: 'page.home.title', svg: 'home' }, l: 'default', r: 'default' },
  },
  {
    path: '/home/:id(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: postComponent,
    name: 'topHome',
    meta: { title: 'header.home', logo: { m: 'page.home.title', svg: 'mail' }, l: 'default', r: 'default' },
  },
  {
    path: '/home/:id(\\d+)/:pid(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: postComponent,
    name: 'postDetail',
    meta: { title: 'header.post', logo: { m: 'page.home.title', svg: 'mail' }, l: 'default', r: 'default' },
  },
  {
    path: '/talk/:id(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topTalk,
    name: 'topTalk',
    meta: { title: 'header.talk-list', logo: { m: 'page.talk.title', svg: 'talk' }, l: 'default', r: 'default' },
  },
  {
    path: '/talk/:id(\\d+)/:talk_id(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topTalk,
    name: 'talkDetail',
    meta: { title: 'header.talk', logo: { m: 'page.talk.title', svg: 'talk' }, l: 'default', r: 'default' },
  },
  {
    path: '/calendar/:id(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topCalendar,
    name: 'topCalendar',
    meta: {
      title: 'header.calendar',
      logo: { m: 'page.calendar.title', svg: 'c-calendar' },
      l: 'default',
      r: 'default',
    },
  },
  {
    path: '/calendar/:id(\\d+)/:t(\\d{6}|n)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topCalendar,
    name: 'calendarYm',
    meta: { title: 'header.album', logo: { m: 'page.calendar.title', svg: 'c-calendar' }, l: 'default', r: 'default' },
  },
  {
    path: '/member/:id(\\d+)/invite/:lang([^0-9/]+)?/:guest(guest)?',
    component: memberInvite,
    name: 'memberInvite',
    meta: {
      title: 'page.member.invite.title',
      logo: { m: 'page.member.title', svg: 'group' },
      l: 'default',
      r: 'default',
    },
  },
  {
    path: '/member/:id(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topMember,
    name: 'topMember',
    meta: { title: 'header.member', logo: { m: 'page.member.title', svg: 'group' }, l: 'default', r: 'default' },
  },
  {
    path: '/album/:id(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topAlbum,
    name: 'topAlbum',
    meta: { title: 'header.album', logo: { m: 'page.album.title', svg: 'photo' }, l: 'default', r: 'default' },
  },
  {
    path: '/album/:id(\\d+)/:t(\\d{6}|n)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topAlbum,
    name: 'albumYm',
    meta: { title: 'header.album', logo: { m: 'page.album.title', svg: 'photo' }, l: 'default', r: 'default' },
  },
  {
    path: '/viewer/:id(\\d+)/:fid(\\d+)/:lang([^0-9/]+)?/:guest(guest)?',
    component: topAlbum,
    name: 'viewer',
    meta: { title: 'header.album', logo: { m: 'page.album.title', svg: 'photo' }, l: 'default', r: 'default' },
  },
  {
    path: '/community/:id(\\d+)/setting/:lang([^0-9/]+)?/:guest(guest)?',
    component: communitySetting,
    name: 'communitySetting',
    meta: {
      title: 'page.community.setting.title',
      logo: { m: 'page.community.setting.title', svg: 'setting' },
      l: 'default',
    },
  },
  {
    path: '/community/create',
    component: communityCreate,
    name: 'communityCreate',
    meta: {
      title: 'page.community.create_community.title',
      logo: { m: 'page.community.create_community.title', svg: 'group' },
      l: 'create-community',
    },
  },
  {
    path: '/join/:type(c|m|o|d)/:code',
    name: 'join',
    component: viewInvitation,
    meta: { title: 'page.member.invite.to_community.title', logo: { m: 'none' }, c: false, r: 'default' },
  },
  {
    path: '/mypage/',
    component: mypageSetting,
    name: 'mypageSetting',
    meta: {
      title: 'page.mypage.title',
      logo: { m: 'page.mypage.title', svg: 'account-circle' },
      c: false,
      l: 'mypage',
    },
  },
  {
    path: '/setting/',
    component: setting,
    name: 'setting',
    meta: { title: 'common.env_setting', logo: { m: 'common.env_setting', svg: 'translate' }, c: false, l: 'setting' },
  },
  {
    path: '/change/:id(\\d+)',
    /* change community id from previous path */
    beforeEnter: (to, from, next) => {
      if (from.path === '/') {
        // root path to /home/:id/all
        return next('/home/' + to.params.id);
      }

      var pathes = location.pathname.split('/');
      if (pathes.length < 3 || pathes[1] == 'change') {
        // escape self infinite redirect loop
        return next('/home/' + to.params.id);
      }

      if (pathes[2].match(/^([0]{1}|[1-9]{1}[0-9]*)$/) == null) {
        // 2nd path :id is not number
        return next(false);
      }

      // replace :id and redirect
      var nextPath = '/' + pathes[1] + '/' + to.params.id;
      pathes.shift();
      pathes.shift();
      pathes.shift();
      if (pathes.length == 0) {
        return next(nextPath + location.search + location.hash);
      }

      return next(nextPath + '/' + pathes.join('/') + location.search + location.hash);
    },
    name: 'changeCommunity',
  },
  {
    path: '*',
    component: notFound,
    name: 'notFound',
    meta: { title: 'page.setting.title', logo: { m: 'none' }, c: false },
  },
];
